var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message"},[_c('user-center-temp',{attrs:{"active-index":_vm.activeIndex,"item-category":_vm.messageCategory,"title":'我的消息'},on:{"change-active-index":_vm.changeActiveIndex}},[_c('div',{staticClass:"message-list"},[_c('p',{staticClass:"no-message"},[_vm._v("\n\t\t\t\t无未读"+_vm._s(_vm.messageCategory[_vm.activeIndex].item)+"。\n\t\t\t")])])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6c2a044","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyMessage.vue
// module id = null
// module chunks = 